import * as types from './mutation-types'
import { getUserInfo, getMisUserInfo, logout } from 'api/common'
import { getNotifyCount } from 'api/tripNotify.js'
import * as getters from './getters'
import { CustomsBuilder } from 'Auth/SimplePermissions';

// for count api
let ls = null;
const LSKey = 'NOTP-AJAX-COUNT';
try {
    const test = '__localstorage-test__'
    window.localStorage.setItem(test, test)
    window.localStorage.removeItem(test)
    ls = window.localStorage;
} catch (e) {
    if (Owl) {
        Owl.addError(`Local storage is not supported`, {
            level: 'info',
            combo: false,
        })
    }
}

export const getUser = ({ commit, state, dispatch }, force) => {
    const user = getters.account(state)
    if (!force && user.id) {
        return user
    }
    return getUserInfo()
        .then((result) => {
            commit(types.SET_BIZ_USER_INFO, result.data)
            let customs = CustomsBuilder.buildCustoms(result.data.authBizlineInfos);
            commit(types.SET_CUSTOMS, customs);
            return result.data
        });
}

export const getMisUser = ({ commit, state, dispatch }, force) => {
    if (!force && state.misUser.id) {
        return state.misUser
    }
    return getMisUserInfo()
        .then((data) => {
            commit(types.SET_MIS_USER_INFO, data)
            return data
        })
}

export const doLogout = ({ commit, state, dispatch }) => {
    return logout()
        .then((data) => {
            commit(types.CLEAR_USER_INFO)
        })
}

export const updatePageAccountType = ({ commit, state, dispatch }, type) => {
    commit(types.SET_PAGE_ACCOUNT_TYPE, type)
}

export const updateBeforeLogin = ({ commit, state, dispatch }, target) => {
    commit(types.SET_FROM_PAGE, target)
}

// for counter demo
export const incrementAsync = ({ commit }) => {
    setTimeout(() => {
        commit('INCREMENT')
    }, 200)
}

// 消息系统
export const getCount = async ({ commit }) => {
    // 断网不发起请求
    if (navigator && navigator.onLine === false) {
        return true;
    }
    if (ls) {
        const now = (new Date()).getTime();
        if (!!ls[LSKey]) {
            const time = ls[LSKey];
            if (now - time < 25*1000) { // 小于25秒
                return true;
            }
        }
        ls.setItem(LSKey, now);
    }
    try {
        const response = await getNotifyCount()
        commit(types.SET_TRIP_NOTIFY, response.data)
    } catch (e) {
        if (Owl) {
            Owl.addError(`Message Count Error ${e.status === 1?'- not login':'- other'}`, {
                level: 'info',
                combo: false,
                tags: {message: e.message}
            })
        }
        if (e.status === 1) return false;
    }
    return true;
}

// webSocket 消息系统
export const setCount = ({ commit }, data) => {
    commit(types.SET_TRIP_NOTIFY, data)
    if (ls) {
        const now = (new Date()).getTime();
        ls.setItem(LSKey, now);
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js